<template>
  <div>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Fecha:</label>
        <CInput
          :value.sync="$v.form.date.$model"
          :isValid="checkIfValid('date')"
          type="date"
          :horizontal="{ input: 'col-sm-12' }"
          invalidFeedback="Campo requerido"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Trabajador:</label>
        <v-select
          v-model="form.trabajador"
          :options="trabajadores"
          class="margin-multi"
          :loading="isLoadingPage"
          placeholder="Selecciona una trabajador"
        >
          <template #open-indicator="{ attributes }">
            <CIcon
              v-bind="attributes"
              class="cursor-p"
              name="cil-caret-bottom"
            />
          </template>
        </v-select>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Actividad:</label>
        <v-select
          v-model="form.actividad"
          :options="actividades"
          class="margin-multi cursor-p"
          @input="filtrarActividad()"
          :loading="isLoadingPage"
          placeholder="Selecciona una actividad"
        >
          <template #open-indicator="{ attributes }">
            <CIcon
              v-bind="attributes"
              class="cursor-p"
              name="cil-caret-bottom"
            />
          </template>
          <template #no-options>Sin resultados.</template>
        </v-select>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9">
        <CInput
          :value.sync="$v.form.cantidad.$model"
          :isValid="checkIfValid('cantidad')"
          :label="`Cantidad producida${getUnidad()}: `"
          placeholder="Cantidad producida..."
          type="number"
        />
      </CCol>
    </CRow>

    <CRow v-if="isFijo">
      <CCol sm="11" md="8" lg="8">
        <CInput
          v-model="form.cantidadCosto"
          :label="`Cantidad a pagar${getUnidadPagar()}:`"
          placeholder="Cantidad a pagar..."
          type="number"
        />
      </CCol>
      <CCol>
        <!-- <CCol v-if="configurationToggle"> -->
        <label>Tiempo extra:</label>
        <br />
        <CSwitch
          :checked="form.tiempo_extra"
          @update:checked="tiempoExtra()"
          class="mx-1"
          color="primary"
          variant="3d"
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Ubicaciones:</label>
        <div class="d-flex margin-multi align-items-center">
          <MultiSelectC
            v-model="form.ubicaciones"
            :options="ubicaciones"
            :multiple="true"
            label="label"
            :loading="isLoadingPage"
            track-by="label"
            placeholder="Selecciona uno o varias ubicaciones"
            :close-on-select="false"
            :clear-on-select="false"
          >
            <template #no-options>Sin resultados.</template>
          </MultiSelectC>
          <transition name="fade">
            <div
              v-show="form.ubicaciones && form.ubicaciones.length"
              @click="cleanMulti()"
            >
              <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
            </div>
          </transition>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <CTextarea
          :value.sync="form.comentarios"
          :label="`Comentarios: `"
          placeholder="Comentarios..."
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <KlayFileDD
          :fetching="fetching"
          v-model="form.medias"
          :label="`Anexos: `"
          @onFetch="onFetch"
          @onErrorFetch="onErrorFetch"
          :fetchMethod="pushMedia"
          :baseSrc="$store.getters.MediaGet"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

export default {
  name: "LaborForm",
  mixins: [validationMixin],
  components: {
    MultiSelectC: Multiselect,
    vSelect,
  },
  validations: {
    form: {
      date: {
        required,
      },
      cantidad: {
        required,
        notNegative: (value) => value >= 0,
      },
      cantidadCosto: {
        required,
      },
    },
  },
  data() {
    return {
      isFijo: false,
      form: {
        date: "",
        trabajador: null,
        actividad: null,
        cantidad: "",
        cantidadCosto: "",
        comentarios: "",
        ubicaciones: [],
        medias: [],
        tiempo_extra: false,
      },
    };
  },
  created() {
    this.$emit("handledSubmit", this.handledSubmit);
    this.$emit("setData", this.setData);
  },
  methods: {
    tiempoExtra() {
      this.form.tiempo_extra = !this.form.tiempo_extra;
    },
    onFetch() {
      this.$emit("onFetch", {});
    },
    onErrorFetch(err) {
      this.$emit("onErrorFetch", err);
    },

    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    handledSubmit() {
      this.validateUbicacion();
      this.validateLabor();
      if (this.isValidDate && this.isValidCantidad) {
        if (!this.form.trabajador) {
          return {
            error: "El campo trabajador es obligatorio",
            warningModal: true,
          };
        }

        if (!this.form.actividad) {
          return {
            error: "El campo actividad es obligatorio",
            warningModal: true,
          };
        }
        if (!this.validateUbicacion()) {
          return {
            error: "El campo ubicaciones es obligatorio",
            warningModal: true,
          };
        }

        this.isLoading = true;
        let newDate = moment(this.form.date, "YYYY-MM-DD HH:mm:ss");
        this.form.ubicaciones ? "" : (this.form.ubicaciones = []);
        // let valueUbicaciones = this.multi.map(item => item.value);
        let valueUbicaciones = this.validateUbicacion();
        return {
          schema: "labores",
          payload: {
            encabezado: {
              fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
              trabajador_id: this.form.trabajador
                ? this.form.trabajador.value
                : "",
              actividad_id: this.form.actividad
                ? this.form.actividad.value
                : "",
              tiempo_extra: this.form.tiempo_extra,
              cantidad: Number(this.form.cantidad),
              ubicaciones: valueUbicaciones,
              ...(this.isFijo
                ? { cantidad_costo: Number(this.form.cantidadCosto) }
                : {}),
              ubicacion_raiz_id: this.ubicacionRaiz
                ? this.ubicacionRaiz.value
                : null,
              comentarios: this.form.comentarios || "",
            },
            anexos: this.form.medias,
          },
        };
      }
      return { skip: true };
    },
    setData(data) {
      Object.assign(this.form, data);
      this.filtrarActividad()
    },

    getUnidad() {
      if (this.form.actividad) {
        // let tipo_pago = "";
        const actSelect = this.actividadesAll.find(
          (actividad) => actividad.id == this.form.actividad.value
        );
        return actSelect ? ` (${actSelect.payload.unidad})` : "";
      }
      return "";
    },
    getUnidadPagar() {
      if (this.form.actividad && this.form.trabajador) {
        let tipo_pago = "";
        const actSelect = this.actividadesAll.find(
          (actividad) => actividad.id == this.form.actividad.value
        );
        actSelect ? (tipo_pago = actSelect.payload.tipo_pago) : "";

        if (tipo_pago.toLowerCase() == "fijo") {
          const trabSelect = this.trabajadoresAll.find(
            (trabajador) => trabajador.id == this.form.trabajador.value
          );
          if (trabSelect) {
            return this.form.tiempo_extra
              ? ` (${trabSelect.payload.unidad_extra})`
              : ` (${trabSelect.payload.unidad})`;
          }
        }
      }
      return "";
    },

    filtrarActividad() {
      if (this.form.actividad) {
        // console.log();
        const actSelect = this.actividadesAll.find(
          (actividad) => actividad.id == this.form.actividad.value
        );
        if (actSelect.payload.tipo_pago.toLowerCase() === "fijo") {
          this.isFijo = true;
        } else {
          this.isFijo = false;
          this.form.tiempo_extra = false;
        }
      }
      console.log(this.form.tiempo_extra);
    },
    validateUbicacion() {
      if (this.form.ubicaciones&&this.form.ubicaciones.length > 0) {
        const newUbicaciones = this.form.ubicaciones.map((ubi) => {
          return ubi.value;
        });
        return newUbicaciones;
      } else {
        return null;
      }
    },
    validateLabor() {
      this.$v.form.date.$touch();
      this.$v.form.cantidad.$touch();
      this.isFijo ? this.$v.form.cantidadCosto.$touch() : "";
      // this.$v.equivalencia_6oz.$touch();
    },
    cleanMulti() {
      this.form.ubicaciones = [];
    },
  },
  computed: {
    isValidDate() {
      return !this.$v.form.date.$invalid;
    },

    isValidCantidad() {
      return !this.$v.form.cantidad.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
  },
  props: {
    ubicaciones: {
      type: Array,
      required: true,
      default: () => [],
    },
    trabajadores: {
      type: Array,
      required: true,
      default: () => [],
    },
    actividades: {
      type: Array,
      required: true,
      default: () => [],
    },
    ubicacionesAll: {
      type: Array,
      required: true,
      default: () => [],
    },
    trabajadoresAll: {
      type: Array,
      required: true,
      default: () => [],
    },
    actividadesAll: {
      type: Array,
      required: true,
      default: () => [],
    },
    isLoadingPage: {
      type: Boolean,
      required: true,
      default: false,
    },
    fetching: {
      type: Boolean,
      required: true,
      default: false,
    },
    pushMedia: {
      type: Function,
      required: true,
      default: () => {},
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
